import {HttpClient} from '@angular/common/http'
import {inject, Service} from '@angular/core'
import {BankIDVerificationData} from '@sparbanken-syd/id-be'
import {ConfigService} from '@sparbanken-syd/sparbanken-syd-bankid'
import {Observable} from 'rxjs'
import {environment} from '../../environments/environment'
import {ADMIN_ROLE, USER_ROLE} from '../application/app'


@Service()
export class DataService {
  private readonly configService = inject(ConfigService)
  private readonly http = inject(HttpClient)

  public getAllTransactions(): Observable<BankIDVerificationData[]> {
    let url = `${environment.bilAPIUrl}/admin` // Default URL

    if (this.configService.roles().includes(ADMIN_ROLE)) {
      url = `${environment.bilAPIUrl}/admin`
    } else if (this.configService.roles().includes(USER_ROLE)) {
      url = `${environment.bilAPIUrl}/user`
    }
    return this.http.get<BankIDVerificationData[]>(url)
  }
}
